import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface LeadDocketLogListGridActionCellRendererParams extends ICellRendererParams {
    viewDetails: (params: LeadDocketLogListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'lead-docket-log-grid-action-cell',
    template:
        `@if (leadDocketSummaryLog) {
  <button type="button"
    class="ace-btn btn-primary has-icon grid-action-button"
    (click)="params.viewDetails(params)"
    helpTooltip
    helpContentId="app.view"
    position="bottom">
    <i class="fa fa-pencil"></i>
  </button>
}`,
    standalone: false
})
export class LeadDocketLogListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: LeadDocketLogListGridActionCellRendererParams;
    leadDocketSummaryLog: Core.LeadDocketSummaryLogModel;

    agInit(params: LeadDocketLogListGridActionCellRendererParams): void {
        this.params = params;
        this.leadDocketSummaryLog = params.data as Core.LeadDocketSummaryLogModel;
    }

    refresh(): boolean {
        return false;
    }
}
